import React from "react";
import { Layout, Row, Col } from "antd";
import { TwitterOutlined, InstagramFilled } from "@ant-design/icons";

export default function Footer() {
  return (
    <Layout.Footer
      style={{ backgroundColor: "#00A0EA", height: "160px" }}
      id="footer"
    >
      <Row
        align="middle"
        justify="space-between"
        style={{ marginLeft: 32, marginRight: 80 }}
      >
        <Col>
          <img
            className="header_logo"
            alt="Carenting Logo"
            src={process.env.PUBLIC_URL + "/asset/logo.png"}
            style={{
              height: "48px",
            }}
          />
        </Col>
        <Col>
          <ul className="medsos">
            <li>
              <TwitterOutlined /> loremipsum
            </li>
            <li>
              <InstagramFilled /> loremipsum
            </li>
          </ul>
        </Col>
      </Row>
      <div
        style={{
          textAlign: "center",
          fontSize: "16px",
          color: "#ffffff",
          marginBottom: 24
        }}
      >
        Copyright@2020 Carenting
      </div>
    </Layout.Footer>
  );
}
